let obj = require("./inflate.min.js");


/**
 * 
 * @module utils 工具 
 */

/** 
 * 
 * @type {Zlib} 
 * 
 **/
let Zlib = obj.Zlib;
/**
 *从u8生成str
 *
 * @export
 * @param {Uint8Array} u8array
 * @param {string} [encode="utf-8"]
 * @return {Promise} 
 */
export function u8arrayToStr(u8array, encode = "utf-8") {
    let blob = new Blob([u8array]);
    let fr = new FileReader();
    fr.readAsText(blob, encode);
    let promise = new Promise(function (resolve, reject) {
        fr.onloadend = function (a) {
            let str = fr.result;
            resolve(str);
        };
    });
    return promise;
};

/**
 *zlib解压
 *
 * @export
 * @param {Uint8Array} u8array
 * @return {Uint8Array} 
 */
export function inflate(u8array) {
    let inflate = new Zlib.Inflate(u8array);
    let ret = inflate.decompress();
    return ret;
};


/**
 *以Stream方式从Blob中取出uint8Array，数据量大时会失败
 *
 * @export
 * @param {Blob} blob
 * @param {Number} [size=blob.size]
 * @return {Promise} 
 */
export async function getUint8ArrayFromBlob(blob, size = blob.size) {
    let stream = blob.stream();
    let reader = stream.getReader();
    let mergedArray = new Uint8Array(size);
    let done = false;
    let pos = 0;
    do {
        let r = reader.read();
        let content = await r;
        done = content.done;
        if (!done) {
            let value = content.value;
            mergedArray.set(value, pos);
            pos += value.byteLength;
        }
    } while (!done);
    return mergedArray;
};